<ion-header class="chat-config-drawer" [ngClass]="{ active: isDrawerOpen }">
  <div class="constrained-content config-container flexed">
    <div class="config-item start">
      <ion-label class="input-label">Selected Agent 1</ion-label>
      <ion-select
        [(ngModel)]="selectedAgent1"
        class="select-outline config-input"
        aria-label="Model"
        interface="popover"
        placeholder="None Selected"
      >
        <ion-select-option *ngFor="let agent of agents" [value]="agent.id">{{
          agent.name
        }}</ion-select-option>
      </ion-select>
    </div>
    <div class="config-item">
      <ion-label class="input-label">Selected Agent 2</ion-label>
      <ion-select
        [(ngModel)]="selectedAgent2"
        class="select-outline config-input"
        aria-label="Model"
        interface="popover"
        placeholder="None Selected"
      >
        <ion-select-option *ngFor="let agent of agents" [value]="agent.id">{{
          agent.name
        }}</ion-select-option>
      </ion-select>
    </div>
  </div>
  <ion-button
    (click)="toggleDrawer()"
    class="icon-button chat-config-drawer-toggle"
    fill="clear"
    color="dark"
  >
    Toggle config drawer
    <ion-icon
      [name]="isDrawerOpen ? 'chevron-up-outline' : 'chevron-down-outline'"
      slot="end"
    ></ion-icon>
  </ion-button>
</ion-header>

<ion-content>
  <ion-list class="message-list transparent-bg">
    <ng-container *ngIf="!displayedMessages.length">
      <ion-item class="empty-message-list-content" lines="none">
        <span class="empty-message-list-placeholder">
          Use the message composer below to start a conversation with your AI
          agent
        </span>
      </ion-item>
    </ng-container>
    <ion-item
      *ngFor="let message of displayedMessages"
      class="message-container"
    >
      <ng-container *ngIf="message.message1">
        <div class="agent-messages-container flexed">
          <div class="agent-message-container left">
            <div class="message-list-photo">
              <app-avatar
                size="36"
                [style.width]="'36px'"
                [style.height]="'36px'"
                [name]="'Assistant'"
              >
              </app-avatar>
            </div>
            <ion-card class="outline-card message-content-container">
              <span>
                <span>
                  <strong>{{ "Assistant" }}</strong>
                </span>
                <span
                  class="message-timestamp"
                  title="{{ message.message1.timestamp }}"
                >
                  <span> • {{ message.message1.timestamp }}</span>
                </span>
              </span>
              <p [innerHTML]="convertToMarkdown(message.message1.content)"></p>
              <ng-container *ngIf="message.message1.suggestedTicketDetails">
                <ion-card class="outline-card embedded-card-content">
                  <p><strong>Suggested Ticket:</strong></p>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Project</p>
                    </ion-label>
                    <ion-label slot="end">
                      {{ message.message1.suggestedTicketDetails.projectName }}
                    </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Ticket Type</p>
                    </ion-label>
                    <ion-label slot="end">
                      {{
                        message.message1.suggestedTicketDetails.ticketTypeName
                      }}
                    </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Title</p>
                    </ion-label>
                    <ion-label slot="end">
                      {{ message.message1.suggestedTicketDetails.title }}
                    </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Summary</p>
                    </ion-label>
                    <ion-label slot="end" class="ticket-summary">
                      {{ message.message1.suggestedTicketDetails.summarySoFar }}
                    </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Priority</p>
                    </ion-label>
                    <ion-label slot="end">
                      <ng-container
                        *ngIf="
                          getEmojiForPriority(
                            message.message1.suggestedTicketDetails.priority
                          ) | colonToEmoji as emojiString
                        "
                      >
                        <img
                          *ngIf="isURL(emojiString)"
                          [src]="emojiString"
                          alt="Priority Emoji"
                          style="
                            width: 1em;
                            height: 1em;
                            vertical-align: -0.125em;
                            margin-right: 0.075em;
                          "
                        />
                        <span
                          *ngIf="!isURL(emojiString)"
                          style="margin-right: 5px"
                          >{{ emojiString }}</span
                        >
                      </ng-container>
                      {{
                        getPriorityLabel(
                          message.message1.suggestedTicketDetails.priority
                        ) || message.message1.suggestedTicketDetails.priority
                      }}
                    </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Tags</p>
                    </ion-label>
                    <ion-label slot="end">
                      <ion-chip
                        *ngFor="
                          let tag of message.message1.suggestedTicketDetails
                            .tagNames
                        "
                      >
                        {{ tag }}
                      </ion-chip>
                    </ion-label>
                  </ion-item>
                </ion-card>
              </ng-container>
              <ng-container
                *ngIf="
                  message.message1.citations &&
                  message.message1.citations.length
                "
              >
                <ion-card class="outline-card embedded-card-content">
                  <p><strong>Citations:</strong></p>
                  <ion-item *ngFor="let citation of message.message1.citations">
                    <ion-label>
                      <a [href]="citation.url">{{ citation.title }}</a>
                    </ion-label>
                  </ion-item>
                </ion-card>
              </ng-container>
              <ng-container
                *ngIf="
                  message.message1.reasoningSteps &&
                  message.message1.reasoningSteps.length
                "
              >
                <ion-card class="outline-card embedded-card-content">
                  <p><strong>Reasoning:</strong></p>
                  <ion-item
                    *ngFor="
                      let reasoningStep of message.message1.reasoningSteps
                    "
                  >
                    <p>{{ reasoningStep }}</p>
                  </ion-item>
                </ion-card>
              </ng-container>
              <ng-container
                *ngIf="
                  isViewAgentThoughtsEnabled() &&
                  message.message1.formattedThoughts &&
                  message.message1.formattedThoughts.length
                "
              >
                <ion-accordion-group class="show-thoughts-accordion-group">
                  <ion-accordion
                    class="show-thoughts-accordion"
                    value="show thinking"
                  >
                    <ion-item slot="header" class="accordion-header">
                      <p><strong>Show Thinking</strong></p>
                      <ion-icon
                        style="height: 1rem"
                        name="warning-outline"
                        color="warning"
                        *ngIf="message.message1.aiThoughtsShowLowConfidence"
                        ngxTippy="Warning: Some of the thoughts have low confidence scores"
                      ></ion-icon>
                    </ion-item>
                    <ion-card
                      slot="content"
                      class="outline-card embedded-card-content"
                    >
                      <ion-item
                        *ngFor="
                          let thought of message.message1.formattedThoughts
                        "
                      >
                        <ion-label>
                          <h3>{{ thought.subject }}</h3>
                          <p class="thought-result">{{ thought.result }}</p>
                          <ng-container
                            *ngIf="getObjectEntries(thought.aspects).length"
                          >
                            <ion-button
                              expand="block"
                              fill="clear"
                              (click)="
                                thought.showThoughtAspects =
                                  !thought.showThoughtAspects
                              "
                              style="margin: 20px 0"
                            >
                              <ion-icon
                                [name]="
                                  thought.showThoughtAspects
                                    ? 'chevron-up-outline'
                                    : 'chevron-down-outline'
                                "
                                class="padded-icon"
                              ></ion-icon>
                              Show More Details
                            </ion-button>
                            <ng-container *ngIf="thought.showThoughtAspects">
                              <ng-container
                                *ngIf="
                                  thought.aspects.aspect_format ===
                                  ASPECT_FORMATS.KB_SEARCH_RESULTS
                                "
                              >
                                <ion-item
                                  *ngFor="
                                    let searchResult of thought.aspects
                                      .all_search_results
                                  "
                                >
                                  <ion-label>
                                    <a [href]="searchResult.url">{{
                                      searchResult.title
                                    }}</a>
                                  </ion-label>
                                </ion-item>
                              </ng-container>
                              <ion-grid>
                                <ng-container
                                  *ngIf="!thought.aspects.aspect_format"
                                >
                                  <ion-row
                                    *ngFor="
                                      let aspect of getObjectEntries(
                                        thought.aspects
                                      )
                                    "
                                  >
                                    <ion-col>
                                      <p>{{ aspect.key }}</p>
                                    </ion-col>
                                    <ion-col>
                                      <p>{{ aspect.value }}</p>
                                    </ion-col>
                                  </ion-row>
                                </ng-container>
                              </ion-grid>
                            </ng-container>
                          </ng-container>
                        </ion-label>
                      </ion-item>
                    </ion-card>
                  </ion-accordion>
                </ion-accordion-group>
              </ng-container>
            </ion-card>
          </div>
          <div class="agent-message-container">
            <div class="message-list-photo">
              <app-avatar
                size="36"
                [style.width]="'36px'"
                [style.height]="'36px'"
                [name]="'Assistant'"
              >
              </app-avatar>
            </div>
            <ion-card class="outline-card message-content-container">
              <span>
                <span>
                  <strong>{{ "Assistant" }}</strong>
                </span>
                <span
                  class="message-timestamp"
                  title="{{ message.message2.timestamp }}"
                >
                  <span> • {{ message.message2.timestamp }}</span>
                </span>
              </span>
              <p [innerHTML]="convertToMarkdown(message.message2.content)"></p>
              <ng-container *ngIf="message.message2.suggestedTicketDetails">
                <ion-card class="outline-card embedded-card-content">
                  <p><strong>Suggested Ticket:</strong></p>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Title</p>
                    </ion-label>
                    <ion-label slot="end">
                      {{ message.message2.suggestedTicketDetails.title }}
                    </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Priority</p>
                    </ion-label>
                    <ion-label slot="end">
                      <ng-container
                        *ngIf="
                          getEmojiForPriority(
                            message.message2.suggestedTicketDetails.priority
                          ) | colonToEmoji as emojiString
                        "
                      >
                        <img
                          *ngIf="isURL(emojiString)"
                          [src]="emojiString"
                          alt="Priority Emoji"
                          style="
                            width: 1em;
                            height: 1em;
                            vertical-align: -0.125em;
                            margin-right: 0.075em;
                          "
                        />
                        <span
                          *ngIf="!isURL(emojiString)"
                          style="margin-right: 5px"
                          >{{ emojiString }}</span
                        >
                      </ng-container>
                      {{
                        getPriorityLabel(
                          message.message2.suggestedTicketDetails.priority
                        ) || message.message2.suggestedTicketDetails.priority
                      }}
                    </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Ticket Type</p>
                    </ion-label>
                    <ion-label slot="end">
                      {{
                        message.message2.suggestedTicketDetails.ticketTypeName
                      }}
                    </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-label slot="start">
                      <p>Summary</p>
                    </ion-label>
                    <ion-label slot="end" class="ticket-summary">
                      {{ message.message2.suggestedTicketDetails.summarySoFar }}
                    </ion-label>
                  </ion-item>
                </ion-card>
              </ng-container>
              <ng-container
                *ngIf="
                  message.message2.citations &&
                  message.message2.citations.length
                "
              >
                <ion-card class="outline-card embedded-card-content">
                  <p><strong>Citations:</strong></p>
                  <ion-item *ngFor="let citation of message.message2.citations">
                    <ion-label>
                      <a [href]="citation.url">{{ citation.title }}</a>
                    </ion-label>
                  </ion-item>
                </ion-card>
              </ng-container>
              <ng-container
                *ngIf="
                  message.message2.reasoningSteps &&
                  message.message2.reasoningSteps.length
                "
              >
                <ion-card class="outline-card embedded-card-content">
                  <p><strong>Reasoning:</strong></p>
                  <ion-item
                    *ngFor="
                      let reasoningStep of message.message2.reasoningSteps
                    "
                  >
                    <p>{{ reasoningStep }}</p>
                  </ion-item>
                </ion-card>
              </ng-container>
              <ng-container
                *ngIf="
                  isViewAgentThoughtsEnabled() &&
                  message.message2.formattedThoughts &&
                  message.message2.formattedThoughts.length
                "
              >
                <ion-accordion-group class="show-thoughts-accordion-group">
                  <ion-accordion
                    class="show-thoughts-accordion"
                    value="show thinking"
                  >
                    <ion-item slot="header" class="accordion-header">
                      <p><strong>Show Thinking</strong></p>
                      <ion-icon
                        style="height: 1rem"
                        name="warning-outline"
                        color="warning"
                        *ngIf="message.message2.aiThoughtsShowLowConfidence"
                        ngxTippy="Warning: Some of the thoughts have low confidence scores"
                      ></ion-icon>
                    </ion-item>
                    <ion-card
                      slot="content"
                      class="outline-card embedded-card-content"
                    >
                      <ion-item
                        *ngFor="
                          let thought of message.message2.formattedThoughts;
                          let i = index
                        "
                      >
                        <ion-label>
                          <h3>{{ i + 1 }}. {{ thought.subject }}</h3>
                          <p class="thought-result">{{ thought.result }}</p>
                          <ng-container
                            *ngIf="getObjectEntries(thought.aspects).length"
                          >
                            <ion-button
                              expand="block"
                              fill="clear"
                              (click)="
                                thought.showThoughtAspects =
                                  !thought.showThoughtAspects
                              "
                              style="margin: 20px 0"
                            >
                              <ion-icon
                                [name]="
                                  thought.showThoughtAspects
                                    ? 'chevron-up-outline'
                                    : 'chevron-down-outline'
                                "
                                class="padded-icon"
                              ></ion-icon>
                              Show More Details
                            </ion-button>
                            <ng-container *ngIf="thought.showThoughtAspects">
                              <ng-container
                                *ngIf="
                                  thought.aspects.aspect_format ===
                                  ASPECT_FORMATS.KB_SEARCH_RESULTS
                                "
                              >
                                <ion-item
                                  *ngFor="
                                    let searchResult of thought.aspects
                                      .all_search_results
                                  "
                                >
                                  <ion-label>
                                    <a [href]="searchResult.url">{{
                                      searchResult.title
                                    }}</a>
                                  </ion-label>
                                </ion-item>
                              </ng-container>
                              <ion-grid>
                                <ng-container
                                  *ngIf="!thought.aspects.aspect_format"
                                >
                                  <ion-row
                                    *ngFor="
                                      let aspect of getObjectEntries(
                                        thought.aspects
                                      )
                                    "
                                  >
                                    <ion-col>
                                      <p>{{ aspect.key }}</p>
                                    </ion-col>
                                    <ion-col>
                                      <p>{{ aspect.value }}</p>
                                    </ion-col>
                                  </ion-row>
                                </ng-container>
                              </ion-grid>
                            </ng-container>
                          </ng-container>
                        </ion-label>
                      </ion-item>
                    </ion-card>
                  </ion-accordion>
                </ion-accordion-group>
              </ng-container>
            </ion-card>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!message.message1">
        <div class="message-list-photo">
          <app-avatar
            size="36"
            [style.width]="'36px'"
            [style.height]="'36px'"
            [image]="user.photoURL"
            [name]="user.displayName"
          >
          </app-avatar>
        </div>
        <ion-card class="outline-card message-content-container">
          <span>
            <span>
              <strong>{{ user.displayName }}</strong>
            </span>
            <span class="message-timestamp" title="{{ message.timestamp }}">
              <span> • {{ message.timestamp }}</span>
            </span>
          </span>
          <p>{{ message.content }}</p>
        </ion-card>
      </ng-container>
    </ion-item>
    <ng-container *ngIf="isAgentThinking">
      <ion-item class="message-container">
        <div class="message-list-photo">
          <app-avatar
            size="36"
            [style.width]="'36px'"
            [style.height]="'36px'"
            [name]="'Assistant'"
          >
          </app-avatar>
        </div>
        <ion-card class="outline-card message-content-container">
          <span>
            <span>
              <strong>Assistant</strong>
            </span>
            <span class="message-timestamp">
              <span> • now</span>
            </span>
          </span>
          <p class="agent-thinking-message">Thinking</p>
        </ion-card>
      </ion-item>
    </ng-container>
    <div class="message-composer">
      <ion-card class="message-composer-inner outline-card">
        <ion-textarea
          autoGrow
          placeholder="Compose your message"
          [(ngModel)]="newMessage"
          (keydown)="handleKeyDown($event)"
        ></ion-textarea>
        <ion-button
          class="btn-small"
          [disabled]="isAgentThinking"
          (click)="sendMessage()"
          [color]="!newMessage ? 'light' : 'primary'"
        >
          <ion-icon
            name="send"
            style="font-size: 0.8rem; margin-right: 5px"
          ></ion-icon>
          Send
        </ion-button>
      </ion-card>
    </div>
  </ion-list>
</ion-content>
